module.exports = __webpack_public_path__ + "img/img_mainland_account_open_7.060ae7bd.png";